module.exports = __webpack_public_path__ + "img/wenda.deb93663.png";